import PropTypes from 'prop-types'
import {
  MdOutlineKeyboardDoubleArrowRight,
  MdOutlineKeyboardDoubleArrowLeft
} from 'react-icons/md'
import { Link } from 'react-router-dom'
const MenuItem = ({ list, activeNavItem, handleItemHover, handleClose }) => {
  return (
    <li
      onMouseEnter={handleItemHover}
      className='group/first cursor-pointer  py-3 flex items-start text-2xl 2xl:text-3xl font-semibold'
    >
      {list?.items ? (
        <span
          className={`uppercase flex gap-2 items-center  ${
            activeNavItem && 'underline underline-offset-8'
          }  whitespace-nowrap `}
        >
          <MdOutlineKeyboardDoubleArrowLeft className='invisible group-hover/first:visible' />
          {list?.title}
          <MdOutlineKeyboardDoubleArrowRight className='visible group-hover/first:invisible' />
        </span>
      ) : (
        <Link
          to={list.link}
          onClick={handleClose}
          className={`uppercase flex gap-2 items-center  ${
            activeNavItem && 'underline underline-offset-8'
          }  whitespace-nowrap `}
        >
          <MdOutlineKeyboardDoubleArrowLeft className='invisible group-hover/first:visible' />
          {list?.title}
          <MdOutlineKeyboardDoubleArrowRight className='visible group-hover/first:invisible' />
        </Link>
      )}
      {list.items && list.items.length > 0 && (
        <ul className='hidden pb-1 h-fit hide_scrollbar list-none group-hover/first:flex border-l-2 pl-3 absolute top-0 left-[15rem] xl:left-[20rem] max-h-[calc(100dvh-130px)]  flex-col  gap-6 my-2  menu  overflow-y-auto'>
          {list.items.map((item, index) => (
            <li key={index} className='group'>
              {item?.link?.includes('http') ? (
                <a
                  href={item.link}
                  onClick={handleClose}
                  className=' uppercase cursor-pointer flex  gap-2 items-center  hover:underline-offset-8 hover:underline'
                  target='_blank'
                  rel='noreferrer'
                >
                  {item.name}
                  <MdOutlineKeyboardDoubleArrowRight className='invisible group-hover:visible' />
                </a>
              ) : (
                <Link
                  to={item.link}
                  onClick={handleClose}
                  className='uppercase cursor-pointer flex  gap-2 items-center hover:underline hover:underline-offset-8  '
                >
                  {item.name}
                  <MdOutlineKeyboardDoubleArrowRight className='invisible group-hover:visible' />
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}
    </li>
  )
}
MenuItem.propTypes = {
  list: PropTypes.object,
  activeNavItem: PropTypes.bool,
  handleItemHover: PropTypes.func,
  handleClose: PropTypes.func
}
export default MenuItem
